const apiCache = new Map();

export const fetchFromCacheOrAPI = async (cacheKey, apiFunction, ...apiArgs) => {
  if (apiCache.has(cacheKey)) {
    return apiCache.get(cacheKey);
  } else {
    const response = await apiFunction(...apiArgs);
    apiCache.set(cacheKey, response);
    return response;
  }
};